import { CMS_SITES_LINKS_MAPPER } from '@bcf-v2-configurators/tokens/cms-sites-links-mapper/token';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { provideDiTokenValue } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { TranslationConfig } from '../i18n-cache';

type CmsSeoLandingSite = 'promo-code' | 'mundials-2026-typi';

export type CmsSeoLandingPageRouteFn = (cmsSeoLandingSite: CmsSeoLandingSite) => string;

// no slash on end
export function cmsSeoLandingPageRoutePath(cmsSeoLandingSite: CmsSeoLandingSite, config?: TranslationConfig): string {
  const mapper: Record<string, string | undefined> = provideDiTokenValue(CMS_SITES_LINKS_MAPPER);

  return `/${langRouteI18n(config)}/lps/${mapper[cmsSeoLandingSite] ?? cmsSeoLandingSite}/`;
}
